<template>
  <div class="container-body">
    <div class="d-flex align-items-center justify-content-center">
      <form v-on:submit="submit">
        <div class="form-group row">
          <label for="staticEmail" class="col-sm-4 col-form-label">{{
            $t("Login.Employee")
          }}</label>
          <div class="col-sm-8">
            <input v-model="user" type="text" class="form-control" required />
          </div>
        </div>
        <div class="form-group row">
          <label for="inputPassword" class="col-sm-4 col-form-label">{{
            $t("Login.Password")
          }}</label>
          <div class="col-sm-8">
            <input
              v-model="password"
              type="password"
              class="form-control"
              required
            />
          </div>
        </div>
        <button type="submit" class="custom-mobile-button-login">
          {{ $t("Login.Login") }}
        </button>
        <div style="margin-top: 10px">
          <div v-if="showEmployeeLoginError" class="alert alert-danger">
            {{ $t("Login.LoginError") }}
          </div>
        </div>
        <router-link to="/reset-password">
          {{ $t("ResetPassword.Recover") }}
        </router-link>
      </form>
    </div>
    <div class="footer-body">
      <Version />
    </div>
  </div>
</template>

<script>
import EmployeeMobileDeviceService from "../services/EmployeeMobileDeviceService";
import AccountService from "../services/AccountService";
import LocalStorageService from "../services/LocalStorageService";
import Version from "../components/Version";
import { getEmployeeLanguage, setMomentLocale } from "../utils";
import moment from "moment";

export default {
  name: "EmployeeLogin",
  employeeMobileDeviceService: null,
  accountService: null,
  localStorageService: null,
  data() {
    return {
      loader: {},
      showEmployeeLoginError: false,
      user: "",
      password: "",
      moment: moment
    };
  },
  components: { Version },
  created() {
    this.employeeMobileDeviceService = new EmployeeMobileDeviceService();
    this.accountService = new AccountService();
    this.localStorageService = new LocalStorageService();
    const token = this.localStorageService.getAuthToken();
    const loggedInEmployee = this.localStorageService.getCurrentEmployee();
    if (token && loggedInEmployee) {
      
      return this.$router.push({ name: "work-day", query: { workDate: this.getCurrentDate() } });
    }
  },
  methods: {
    submit(event) {
      event.preventDefault();
      this.showEmployeeLoginError = false;
      this.showServerError = false;
      this.loader = this.$loading.show({});
      this.accountService
        .login(this.user, this.password)
        .then((res) => {
          this.loader.hide();
          const result = res.data;
          this.localStorageService.setAuthToken(result.token);
          this.$root.$emit("onLogin", true);
          this.localStorageService.setCurrentEmployee(result.employee);
          const lang = getEmployeeLanguage(result.employee.language);
          this.$i18n.locale = lang;
          setMomentLocale(lang);

          if(this.$appInsights){
            var validatedId = this.user.replace(/[,;=| ]+/g, "_");
            this.$appInsights.setAuthenticatedUserContext(validatedId);
          }

          return this.$router.push({ name: "work-day", query: { workDate: this.getCurrentDate() } });
        })
        .catch((err) => {
          if (err.response && err.response.status === 400) {
            this.showEmployeeLoginError = true;
          }
          this.loader.hide();
        });
    },
    getCurrentDate(){
      let currentDate = new Date().setHours(0, 0, 0, 0);
      currentDate = moment(currentDate).toISOString();
      return currentDate;
    }
  },
};
</script>

<style>
.custom-mobile-button-login {
  background: #007ad9;
  color:white;
  border: 0px;
  width: 100%;
  padding: 10px;
  font-size: 20px;
  border-radius: 5px;
  z-index: 99;
  margin-top: 20px;
}
</style>